/**
 * Which build this is, in the corner of every page — including the login
 * screen, so "are we on the new version?" is answerable before signing in.
 *
 * Deliberately quiet: it is reference material, not status. It sits at low
 * opacity until you hover it, and it steps aside on narrow screens rather than
 * floating over the content. The values are baked in at build time
 * (vite.config.ts), so they describe the bundle you are actually running, not
 * whatever the server was later told to call itself.
 */
export function BuildStamp() {
  const date = __COMMIT_DATE__ ? new Date(__COMMIT_DATE__) : null;
  const valid = date && !Number.isNaN(date.getTime());

  // "5 Sep 2026" — short enough for the corner, unambiguous about the month.
  const shown = valid
    ? date.toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' })
    : null;

  // The tooltip carries what you would need to actually find the commit.
  const title = [
    __APP_VERSION__,
    __COMMIT_SHA__ ? `commit ${__COMMIT_SHA__}` : null,
    valid ? date.toLocaleString() : null,
  ]
    .filter(Boolean)
    .join(' · ');

  return (
    <div className="build-stamp" title={title}>
      {__APP_VERSION__}
      {shown ? <span className="build-stamp__date"> · {shown}</span> : null}
    </div>
  );
}
